import * as React from "react";

import { Product } from "../../../models";

export interface CartProps {
  chosenProduct?: Product;
}

const Cart = (props: CartProps) => (
  <div className="wizard-footer__cart">
    <span className="wizard-footer__cart-icon" />
    <span className="hidden-xs wizard-footer__cart-text">
      Sản phẩm đã chọn:
    </span>
    <span className="wizard-footer__cart-product">
      {props.chosenProduct && props.chosenProduct.name}
    </span>
  </div>
);

export default Cart;



// WEBPACK FOOTER //
// ./src/routes/Wizard/components/Cart.tsx